import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-kartoteka-menu',
  templateUrl: './kartoteka-menu.component.html',
  styleUrls: ['./kartoteka-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KartotekaMenuComponent {}
